import React, { useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive';
import usePermissions from '../../hooks/usePermissions';
import { Button, Card, Descriptions, Pagination, Popover, Space, Spin, Table, Tabs, Tag, Typography } from 'antd';
import moment from 'moment/moment';
import { MailOutlined, PhoneOutlined, VideoCameraOutlined, FileTextOutlined, MessageOutlined } from '@ant-design/icons';
import ViolationListView from '../../page-components/Violaion&ContactView/ViolationListView';
import paymentOperationsService from '../../services/paymentOperationsService';
import UnauthorizedPage from '../../components/Error/UnauthorizedPage';
import { useSelector } from 'react-redux';


const ContactViolationLogs = () => {

    const { Title, Paragraph } = Typography;
    const { TabPane } = Tabs;
    const { user } = useSelector((state) => state.auth);


    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const { hasPermission } = usePermissions()

    const [data, setData] = useState([]);
    const [violationData, setViolationData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("1");

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: false,
    });

    const fetchData = async (page, pageSize) => {
        setLoading(true);
        try {
            const response = await paymentOperationsService.getRequestedContactClientData(page, pageSize);
            if (response.success) {
                setData(response?.data?.results?.data || []);
                setPagination({
                    ...pagination,
                    total: response?.data?.count || 0,
                    current: page,
                    pageSize,
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchViolationData = async (page, pageSize) => {
        setLoading(true);
        try {
            const response = await paymentOperationsService.getViolationListData(page, pageSize);
            if (response.success) {
                setViolationData(response?.data?.results?.data || []);
                setPagination({
                    ...pagination,
                    total: response?.data?.count || 0,
                    current: page,
                    pageSize,
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (activeTab === "1") {
            fetchData(pagination.current, pagination.pageSize);
        }
        else if (activeTab === "2") {
            fetchViolationData(pagination.current, pagination.pageSize);
        }
    }, [activeTab, pagination.current, pagination.pageSize]);

    const handleTabChange = (key) => {
        setActiveTab(key);
        setPagination({
            current: 1,
            pageSize: 10,
            total: 0,
            showSizeChanger: false,
        });
    };

    const columns = [
        {
            title: "Employee",
            dataIndex: "employee_name",
            key: "employee_name",
            render: (name, record) => {
                return (
                    <>
                        <b>{name}</b>
                        <br />
                        {moment(record.submitted_at).local().format("DD-MM-YYYY hh:mm A")}
                    </>
                );
            },
        },
        {
            title: "Department",
            dataIndex: "employee_department",
            key: "employee_department",
            render: (department, record) => {
                return (
                    <Tag color="blue">{department}</Tag>
                );
            },
        },
        {
            title: "Client & Approval By",
            dataIndex: "client",
            key: "client",
            render: (client, record) => {
                return (
                    <>
                        <b>{client}</b>
                        <br />
                        <span>
                            {record.approved_by_business_head ? "Business Head" : "Sales Rep"}
                        </span>
                    </>
                );
            }
        },
        {
            title: "Contact Method & Prefered Time",
            dataIndex: "proposed_contact_method",
            key: "proposed_contact_method",
            render: (method, record) => {
                let icon;
                let color = '#1890ff';

                switch (method?.toLowerCase()) {
                    case 'phone':
                        icon = <PhoneOutlined style={{ marginRight: 5 }} />;
                        break;
                    case 'email':
                        icon = <MailOutlined style={{ marginRight: 5 }} />;
                        color = '#52c41a';
                        break;
                    case 'video':
                        icon = <VideoCameraOutlined style={{ marginRight: 5 }} />;
                        color = '#eb2f96';
                        break;
                    default:
                        icon = null;
                }

                return (
                    <>
                        <div>
                            <span style={{ color }}>{icon}{method?.charAt(0).toUpperCase() + method?.slice(1)}</span>
                        </div>
                        <div style={{ marginTop: 5, fontSize: 12 }}>
                            {moment(record.preferred_date_time).local().format("DD-MM-YYYY hh:mm A")}
                        </div>
                    </>
                );
            }
        },
        {
            title: "Urgency & Rep",
            dataIndex: "urgency_level",
            key: "urgency_level",
            render: (urgency, record) => {
                let color = '';
                switch (urgency?.toLowerCase()) {
                    case 'high':
                        color = 'red';
                        break;
                    case 'medium':
                        color = 'orange';
                        break;
                    case 'low':
                        color = 'green';
                        break;
                    default:
                        color = 'default';
                }
                return (
                    <>
                        <Tag color={color}>{urgency?.toUpperCase()}</Tag>
                        <br />
                        <div>
                            {record?.sales_representative && record?.sales_representative}
                        </div>

                    </>
                );
            }
        },
        {
            title: "Content",
            key: "content",
            render: (_, record) => (
                <Space>
                    <Popover
                        title="Reason for Contact"
                        content={record.reason_for_contact}
                        trigger="click"
                        overlayStyle={{ maxWidth: '400px' }}
                    >
                        <Button type="link" icon={<FileTextOutlined />}>Reason</Button>
                    </Popover>
                    <Popover
                        title="Proposed Message"
                        content={record.proposed_message}
                        trigger="click"
                        overlayStyle={{ maxWidth: '400px' }}
                    >
                        <Button type="link" icon={<MessageOutlined />}>Message</Button>
                    </Popover>
                </Space>
            )
        },
    ];

    if (user.user.type !== 15) {
        return <UnauthorizedPage />
    }

    return (
        <div style={{ margin: 10, padding: 24, background: "#fff", borderRadius: 8 }}>
            <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                <Paragraph
                    style={{
                        fontWeight: 500,
                        opacity: 0.6,
                        textAlign: "left",
                        margin: 0,
                        padding: 0,
                    }}>
                    Showing{" "}
                    {Math.min(
                        (pagination.current - 1) * pagination.pageSize + 1,
                        pagination.total
                    )}{" "}
                    -
                    {Math.min(
                        pagination.current * pagination.pageSize,
                        pagination.total
                    )}{" "}
                    of {pagination.total}
                </Paragraph>
            </div>
            <Tabs defaultActiveKey="1" onChange={handleTabChange}>
                <TabPane tab="Contact Client List" key="1">
                    {isMobile ? (
                        <Spin spinning={loading} tip="Loading..">
                            <MobileView
                                data={data}
                                pagination={pagination}
                                setPagination={setPagination}
                            />
                        </Spin>
                    ) : (
                        <Table
                            dataSource={data}
                            columns={columns}
                            rowKey="task_id"
                            pagination={{
                                current: pagination.current,
                                pageSize: pagination.pageSize,
                                total: pagination.total,
                                onChange: (page, pageSize) => {
                                    setPagination({ ...pagination, current: page, pageSize });
                                },
                                onShowSizeChange: (current, size) => {
                                    setPagination({ ...pagination, current: 1, pageSize: size });
                                },
                            }}
                            bordered
                            loading={loading}
                            scroll={{ x: 'max-content', }}
                        />
                    )}
                </TabPane>

                <TabPane tab="Violation List" key="2">
                    <ViolationListView
                        violationData={violationData}
                        loading={loading}
                        pagination={pagination}
                        setPagination={setPagination}
                    />
                </TabPane>
            </Tabs>
        </div>
    );
}

const MobileView = ({ data, pagination, setPagination }) => (
    <>
        {data.map((item) => (
            <Card
                key={item.task_id}
                style={{ marginBottom: 16, borderRadius: 8 }}
                bodyStyle={{ padding: 0 }}
                type="inner"
            >
                <Descriptions
                    column={1}
                    size="small"
                    bordered
                    style={{ margin: 0 }}
                >
                    <Descriptions.Item label="Employee Name">{item?.employee_name}</Descriptions.Item>
                    <Descriptions.Item label="Submitted At">{moment(item?.submitted_at).local().format("DD-MM-YYYY hh:mm A")}</Descriptions.Item>
                    <Descriptions.Item label="Employee Department">{item.employee_department}</Descriptions.Item>
                    <Descriptions.Item label="Reason for Contact">{item?.reason_for_contact}</Descriptions.Item>
                    <Descriptions.Item label="Proposed Message">{item?.proposed_message}</Descriptions.Item>
                    <Descriptions.Item label="Urgency Level">{item?.urgency_level}</Descriptions.Item>
                    <Descriptions.Item label="Contact Method">{item?.proposed_contact_method}</Descriptions.Item>
                    <Descriptions.Item label="Client">{item?.client}</Descriptions.Item>
                    <Descriptions.Item label="Date & time">{moment(item?.preferred_date_time).local().format("DD-MM-YYYY hh:mm A")}</Descriptions.Item>
                    <Descriptions.Item label="Sales Representative">{item?.sales_representative}</Descriptions.Item>
                    <Descriptions.Item label="Approvals by">{item?.approved_by_business_head == true ? "Business Head" : "Sales Representative"}</Descriptions.Item>
                </Descriptions>
            </Card>
        ))}

        <div style={{ textAlign: "center", marginTop: 16 }}>
            <Pagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                onChange={(page) => setPagination((prev) => ({ ...prev, current: page }))}
                showSizeChanger={false}
            />
        </div>
    </>
);

export default ContactViolationLogs